import { forwardRef, useEffect, useState } from "react";

import styled from "styled-components/macro";

import { useCardProvider } from "Payments/globalPaymentsStateHooks";
import { motion } from "framer-motion";

import useCreditCardEntryState from "./state";
import {
  InputOutline,
  Placeholder,
  SmallNumberInput,
  iPhoneMini,
  useErrorShakeAnimation,
} from "./styles";

const Zip = forwardRef(({ defaultZip, submitting }, ref) => {
  const { providerIsWePay } = useCardProvider();
  const [isHovering, setIsHovering] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const [{ zip, canBeEdited, isEditing, cardType }, dispatch] =
    useCreditCardEntryState();
  const cardTypeShortname = cardType?.shortname || "";

  const shouldShowDisplayOnly = canBeEdited && !isEditing;

  const { shake: errorShake, animationProps: errorAnimationProps } =
    useErrorShakeAnimation();

  const updateZip = (e) => {
    dispatch({
      type: "Remove Multiple Error Messages",
      messages: ["empty_zip", "invalid_zip"],
    });
    const newValue = e.target.value.replace(/[^\d]/g, "").substr(0, 5);

    if (newValue !== e.target.value) errorShake();

    dispatch({ type: "Set Zip", zip: newValue });
  };

  useEffect(() => {
    if (defaultZip) dispatch({ type: "Set Zip", zip: defaultZip });
  }, [defaultZip]);

  return (
    <Wrapper
      {...errorAnimationProps}
      onHoverStart={() => setIsHovering(true)}
      onHoverEnd={() => setIsHovering(false)}
      data-cy="fund-it-card-zip-input"
    >
      <InputOutline
        isFocused={!submitting && isFocused}
        isHovering={!shouldShowDisplayOnly && !submitting && isHovering}
        style={{ top: "1px" }}
      />
      <ZipPlaceholder>Zip</ZipPlaceholder>
      <ZipInput
        value={zip}
        ref={ref}
        type="text"
        inputMode="numeric"
        name="zip"
        autoComplete="postal-code"
        tabIndex={providerIsWePay ? 5 : 0}
        onChange={updateZip}
        placeholder="90210"
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        disabled={shouldShowDisplayOnly || submitting}
        useDarkPlaceholder={cardTypeShortname === "amex"}
      />
    </Wrapper>
  );
});

Zip.displayName = "NameInput";
export default Zip;

const Wrapper = styled(motion.div)`
  position: relative;
  flex-grow: 0;
  padding: 6px 12px 6px 12px;
  margin-top: 0px;
  display: flex;
  align-items: center;
  @media screen and (max-width: ${iPhoneMini.cssWidth}) {
    padding: 5px 10px 5px 10px;
  }
`;

const ZipInput = styled(SmallNumberInput)`
  font-size: 14px;
  text-align: right;
  width: 76px;
  &::-webkit-input-placeholder,
  &::placeholder {
    transform: translateY(0.5px);
  }
`;
const ZipPlaceholder = styled(Placeholder)`
  top: 50%;
  transform: translateY(-50%);
  margin-top: 2px;
`;
